import NavButton from "../Tools/NavButton";
import { useState } from "react";
import { Colors, invertDark } from "../Assets/Config/color.config";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../config";
import { MyConstants } from "../Constants/MyConstants";
//icons
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ChatBubbleRoundedIcon from "@mui/icons-material/ChatBubbleRounded";
import commonStore from "../Store/marco/commonStore";
import FeedbackModal from "./FeedbackModal";

const UserMenuItem = (props) => {
  const navigate = useNavigate();
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const {
    userName,
    theme,
    showDropDown,
    role,
    isBlueOnion,
    authenticated,
    customEmissionFactorList,
    blueOnionUserDisplayName,
    ...others
  } = props;
  const { logout } = commonStore;
  // const { t } = useTranslation(window.location.pathname.replace("/", ""));
  const { t } = useTranslation("common");
  const { t: tUserMenu } = useTranslation("UserMenu");
  let customEmissionFactorCount = 0;
  if (role === MyConstants.SUPER_ADMIN) {
    customEmissionFactorList?.map((v) => {
      if (!v.isVerified && !v.isRejected) customEmissionFactorCount++;
    });
  }
  return (
    <>
      <NavButton
        startIcon={<AccountCircleIcon />}
        {...others}
        style={{ color: invertDark(theme), minWidth: 0, padding: "6px 0" }}
        customTheme={theme}
      >
        {userName}
      </NavButton>

      {showDropDown && (
        <div
          className="text-center p-2 hover cardStyle"
          style={{
            position: "absolute",
            fontSize: 16,
            top: 65,
            right: 20,
            background: Colors[theme].background,
            color: Colors[theme].primaryColor,
            zIndex: 1,
            borderRadius: 5,
            width: 223,
            cursor: "pointer",
            border: `1px solid ${Colors.lightBlue}`,
          }}
        >
          <div
            className="p-1"
            style={{ textAlign: "left" }}
            onClick={() => navigate("/profile")}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <AccountBoxIcon
                style={{ fontSize: "large", marginRight: "6px" }}
              />
              {t("Profile")}
            </div>
          </div>
          {/* 訂閱內容 */}
          <div
            className="p-1"
            style={{ textAlign: "left" }}
            onClick={() => navigate("/subscription-contents")}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              {/* <i className="bi bi-journal-check pe-2"></i> */}
              <AutoAwesomeIcon
                style={{ fontSize: "large", marginRight: "6px" }}
              />
              {t("Subscription Content")}
            </div>
          </div>
          {/* 更新日誌 */}
          <div
            className="p-1"
            style={{ textAlign: "left" }}
            onClick={() => navigate("/release-notes")}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <FactCheckIcon
                style={{ fontSize: "large", marginRight: "6px" }}
              />
              {t("Release Note")}
            </div>
          </div>

          <div
            className="p-1"
            style={{ textAlign: "left" }}
            onClick={() => setFeedbackModalOpen(true)}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <ChatBubbleRoundedIcon
                style={{ fontSize: "large", marginRight: "6px" }}
              />
              {tUserMenu("Problem Feedback")}
            </div>
          </div>

          <div
            className="p-1"
            style={{ textAlign: "left" }}
            onClick={() => logout()}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <ExitToAppIcon
                style={{ fontSize: "large", marginRight: "6px" }}
              />
              {t("Log Out")}
            </div>
          </div>
        </div>
      )}

      <FeedbackModal
        open={feedbackModalOpen}
        onClose={() => setFeedbackModalOpen(false)}
      />
    </>
  );
};

export default UserMenuItem;
